export const idlFactory = ({ IDL }) => {
  const List = IDL.Rec();
  const PublicationObject__1 = IDL.Record({
    'isEditor' : IDL.Bool,
    'publicationName' : IDL.Text,
  });
  const PublicationObject = IDL.Record({
    'isEditor' : IDL.Bool,
    'publicationName' : IDL.Text,
  });
  const UserClaimInfo = IDL.Record({
    'isUserBlocked' : IDL.Bool,
    'maxClaimableTokens' : IDL.Text,
    'subaccount' : IDL.Opt(IDL.Vec(IDL.Nat8)),
    'lastClaimDate' : IDL.Opt(IDL.Text),
    'isClaimActive' : IDL.Bool,
  });
  List.fill(IDL.Opt(IDL.Tuple(IDL.Text, List)));
  const FollowersPrincipals = IDL.Opt(IDL.Tuple(IDL.Text, List));
  const Followers = IDL.Opt(IDL.Tuple(IDL.Text, List));
  const User__1 = IDL.Record({
    'bio' : IDL.Text,
    'socialChannels' : IDL.Vec(IDL.Text),
    'followersArray' : IDL.Vec(IDL.Text),
    'displayName' : IDL.Text,
    'followersCount' : IDL.Nat32,
    'nuaTokens' : IDL.Float64,
    'accountCreated' : IDL.Text,
    'publicationsArray' : IDL.Vec(PublicationObject),
    'claimInfo' : UserClaimInfo,
    'website' : IDL.Text,
    'isVerified' : IDL.Bool,
    'handle' : IDL.Text,
    'followersPrincipals' : FollowersPrincipals,
    'followers' : Followers,
    'avatar' : IDL.Text,
  });
  const AddPublicationReturn = IDL.Variant({
    'ok' : User__1,
    'err' : IDL.Text,
  });
  const Result_2 = IDL.Variant({ 'ok' : IDL.Text, 'err' : IDL.Text });
  const Result_16 = IDL.Variant({ 'ok' : IDL.Opt(IDL.Text), 'err' : IDL.Text });
  const Result_6 = IDL.Variant({ 'ok' : IDL.Bool, 'err' : IDL.Text });
  const Result_3 = IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text });
  const User = IDL.Record({
    'bio' : IDL.Text,
    'socialChannels' : IDL.Vec(IDL.Text),
    'followersArray' : IDL.Vec(IDL.Text),
    'displayName' : IDL.Text,
    'followersCount' : IDL.Nat32,
    'nuaTokens' : IDL.Float64,
    'accountCreated' : IDL.Text,
    'publicationsArray' : IDL.Vec(PublicationObject),
    'claimInfo' : UserClaimInfo,
    'website' : IDL.Text,
    'isVerified' : IDL.Bool,
    'handle' : IDL.Text,
    'followersPrincipals' : FollowersPrincipals,
    'followers' : Followers,
    'avatar' : IDL.Text,
  });
  const Result_1 = IDL.Variant({ 'ok' : User, 'err' : IDL.Text });
  const Result_5 = IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text });
  const Date = IDL.Record({
    'day' : IDL.Nat,
    'month' : IDL.Nat,
    'hour' : IDL.Nat,
    'year' : IDL.Nat,
  });
  const Result_9 = IDL.Variant({ 'ok' : IDL.Vec(IDL.Text), 'err' : IDL.Text });
  const Result_15 = IDL.Variant({
    'ok' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat)),
    'err' : IDL.Text,
  });
  const MetricsGranularity = IDL.Variant({
    'hourly' : IDL.Null,
    'daily' : IDL.Null,
  });
  const GetMetricsParameters = IDL.Record({
    'dateToMillis' : IDL.Nat,
    'granularity' : MetricsGranularity,
    'dateFromMillis' : IDL.Nat,
  });
  const UpdateCallsAggregatedData = IDL.Vec(IDL.Nat64);
  const CanisterHeapMemoryAggregatedData = IDL.Vec(IDL.Nat64);
  const CanisterCyclesAggregatedData = IDL.Vec(IDL.Nat64);
  const CanisterMemoryAggregatedData = IDL.Vec(IDL.Nat64);
  const HourlyMetricsData = IDL.Record({
    'updateCalls' : UpdateCallsAggregatedData,
    'canisterHeapMemorySize' : CanisterHeapMemoryAggregatedData,
    'canisterCycles' : CanisterCyclesAggregatedData,
    'canisterMemorySize' : CanisterMemoryAggregatedData,
    'timeMillis' : IDL.Int,
  });
  const NumericEntity = IDL.Record({
    'avg' : IDL.Nat64,
    'max' : IDL.Nat64,
    'min' : IDL.Nat64,
    'first' : IDL.Nat64,
    'last' : IDL.Nat64,
  });
  const DailyMetricsData = IDL.Record({
    'updateCalls' : IDL.Nat64,
    'canisterHeapMemorySize' : NumericEntity,
    'canisterCycles' : NumericEntity,
    'canisterMemorySize' : NumericEntity,
    'timeMillis' : IDL.Int,
  });
  const CanisterMetricsData = IDL.Variant({
    'hourly' : IDL.Vec(HourlyMetricsData),
    'daily' : IDL.Vec(DailyMetricsData),
  });
  const CanisterMetrics = IDL.Record({ 'data' : CanisterMetricsData });
  const EmailBatchSummary = IDL.Record({
    'id' : IDL.Text,
    'nextAttemptAt' : IDL.Int,
    'attempts' : IDL.Nat,
    'updatedAt' : IDL.Int,
    'lastError' : IDL.Text,
    'recipientCount' : IDL.Nat,
    'firstAttemptedAt' : IDL.Int,
    'authorPrincipal' : IDL.Text,
    'postId' : IDL.Text,
  });
  const Result_11 = IDL.Variant({
    'ok' : IDL.Vec(EmailBatchSummary),
    'err' : IDL.Text,
  });
  const EmailSubscriber = IDL.Record({
    'unsubscribedAt' : IDL.Opt(IDL.Int),
    'verified' : IDL.Bool,
    'userId' : IDL.Opt(IDL.Text),
    'createdAt' : IDL.Int,
    'email' : IDL.Text,
    'verifiedAt' : IDL.Opt(IDL.Int),
    'authorPrincipal' : IDL.Text,
  });
  const Result_14 = IDL.Variant({
    'ok' : IDL.Vec(EmailSubscriber),
    'err' : IDL.Text,
  });
  const UserListItem = IDL.Record({
    'bio' : IDL.Text,
    'socialChannelsUrls' : IDL.Vec(IDL.Text),
    'principal' : IDL.Text,
    'displayName' : IDL.Text,
    'followersCount' : IDL.Text,
    'website' : IDL.Text,
    'isVerified' : IDL.Bool,
    'handle' : IDL.Text,
    'fontType' : IDL.Text,
    'avatar' : IDL.Text,
  });
  const GetHandleByPrincipalReturn = IDL.Variant({
    'ok' : IDL.Opt(IDL.Text),
    'err' : IDL.Text,
  });
  const Result_13 = IDL.Variant({ 'ok' : IDL.Vec(User), 'err' : IDL.Text });
  const Result_12 = IDL.Variant({
    'ok' : IDL.Vec(UserListItem),
    'err' : IDL.Text,
  });
  const NuaBalanceResult = IDL.Variant({ 'ok' : IDL.Text, 'err' : IDL.Text });
  const GetPrincipalByHandleReturn = IDL.Variant({
    'ok' : IDL.Opt(IDL.Text),
    'err' : IDL.Text,
  });
  const Result_10 = IDL.Variant({ 'ok' : UserListItem, 'err' : IDL.Text });
  const SupportedStandard = IDL.Record({ 'url' : IDL.Text, 'name' : IDL.Text });
  const Icrc28TrustedOriginsResponse = IDL.Record({
    'trusted_origins' : IDL.Vec(IDL.Text),
  });
  const Result_8 = IDL.Variant({
    'ok' : IDL.Tuple(IDL.Nat, IDL.Nat),
    'err' : IDL.Text,
  });
  const PublishedArticlePayload = IDL.Record({
    'url' : IDL.Text,
    'title' : IDL.Text,
    'contentHtml' : IDL.Text,
    'authorAvatar' : IDL.Text,
    'publishedAt' : IDL.Int,
    'publicationDisplayName' : IDL.Opt(IDL.Text),
    'publicationHandle' : IDL.Opt(IDL.Text),
    'headerImage' : IDL.Text,
    'authorDisplayName' : IDL.Text,
    'publicationAvatar' : IDL.Opt(IDL.Text),
    'authorHandle' : IDL.Text,
    'isMembersOnly' : IDL.Bool,
    'subtitle' : IDL.Text,
    'authorPrincipal' : IDL.Text,
    'postId' : IDL.Text,
  });
  const Result_7 = IDL.Variant({
    'ok' : IDL.Record({
      'totalRecipients' : IDL.Nat,
      'batchesFailed' : IDL.Nat,
      'batchesSent' : IDL.Nat,
    }),
    'err' : IDL.Text,
  });
  const RegisterUserReturn = IDL.Variant({ 'ok' : User__1, 'err' : IDL.Text });
  const RemovePublicationReturn = IDL.Variant({
    'ok' : User__1,
    'err' : IDL.Text,
  });
  const PaymentMethod = IDL.Variant({
    'Fiat' : IDL.Record({
      'stripeSubscriptionId' : IDL.Text,
      'usdAmountCents' : IDL.Text,
    }),
    'Token' : IDL.Null,
  });
  const SubscriptionTimeInterval = IDL.Variant({
    'LifeTime' : IDL.Null,
    'Weekly' : IDL.Null,
    'Monthly' : IDL.Null,
    'Annually' : IDL.Null,
  });
  const SubscriptionEvent = IDL.Record({
    'startTime' : IDL.Int,
    'subscriptionEventId' : IDL.Text,
    'paymentMethod' : IDL.Opt(PaymentMethod),
    'endTime' : IDL.Int,
    'subscriptionTimeInterval' : SubscriptionTimeInterval,
    'stripeCancelAtPeriodEnd' : IDL.Opt(IDL.Bool),
    'writerPrincipalId' : IDL.Text,
    'paymentFee' : IDL.Text,
    'isWriterSubscriptionActive' : IDL.Bool,
    'readerPrincipalId' : IDL.Text,
  });
  const WriterSubscriptionDetails = IDL.Record({
    'stripeAccountId' : IDL.Opt(IDL.Text),
    'writerSubscriptions' : IDL.Vec(SubscriptionEvent),
    'weeklyFee' : IDL.Opt(IDL.Text),
    'paymentReceiverPrincipalId' : IDL.Text,
    'writerPrincipalId' : IDL.Text,
    'lifeTimeFee' : IDL.Opt(IDL.Text),
    'stripePricing' : IDL.Vec(
      IDL.Tuple(SubscriptionTimeInterval, IDL.Text, IDL.Text)
    ),
    'isSubscriptionActive' : IDL.Bool,
    'annuallyFee' : IDL.Opt(IDL.Text),
    'stripeIsActive' : IDL.Bool,
    'monthlyFee' : IDL.Opt(IDL.Text),
  });
  const ReaderSubscriptionDetails = IDL.Record({
    'readerSubscriptions' : IDL.Vec(SubscriptionEvent),
    'readerNotStoppedSubscriptionsWriters' : IDL.Vec(WriterSubscriptionDetails),
    'readerPrincipalId' : IDL.Text,
  });
  const Result_4 = IDL.Variant({
    'ok' : ReaderSubscriptionDetails,
    'err' : IDL.Text,
  });
  const Validate = IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text });
  const Result = IDL.Variant({
    'ok' : IDL.Record({ 'email' : IDL.Text, 'authorHandle' : IDL.Text }),
    'err' : IDL.Text,
  });
  const UniquePersonProofProvider = IDL.Variant({ 'DecideAI' : IDL.Null });
  const UniquePersonProof = IDL.Record({
    'provider' : UniquePersonProofProvider,
    'timestamp' : IDL.Nat64,
  });
  const VerifyResult = IDL.Variant({
    'Ok' : UniquePersonProof,
    'Err' : IDL.Text,
  });
  return IDL.Service({
    'acceptCycles' : IDL.Func([], [], []),
    'addNuaBalance' : IDL.Func([IDL.Text], [], ['oneway']),
    'addPublication' : IDL.Func(
        [PublicationObject__1, IDL.Text],
        [AddPublicationReturn],
        [],
      ),
    'adminAirDrop' : IDL.Func([IDL.Float64], [Result_2], []),
    'adminGetDecideIdClientId' : IDL.Func([], [Result_16], ['query']),
    'adminIsDecideIdClientSecretSet' : IDL.Func([], [Result_6], ['query']),
    'adminSetDecideIdClientId' : IDL.Func([IDL.Opt(IDL.Text)], [Result_3], []),
    'adminSetDecideIdClientSecret' : IDL.Func(
        [IDL.Opt(IDL.Text)],
        [Result_3],
        [],
      ),
    'availableCycles' : IDL.Func([], [IDL.Nat], ['query']),
    'blockUserFromClaiming' : IDL.Func([IDL.Text], [Result_3], []),
    'checkMyClaimNotification' : IDL.Func([], [], []),
    'claimRestrictedTokens' : IDL.Func([], [Result_1], []),
    'clearAllMyFollowers' : IDL.Func([], [IDL.Text], []),
    'collectCanisterMetrics' : IDL.Func([], [], []),
    'createDecideIdState' : IDL.Func([IDL.Text], [Result_2], []),
    'deleteConfirmedLinkings' : IDL.Func([], [Result_3], []),
    'deleteUser' : IDL.Func([IDL.Text], [Result_5], []),
    'dumpUsers' : IDL.Func([], [IDL.Text], ['query']),
    'followAuthor' : IDL.Func([IDL.Text], [Result_1], []),
    'generateAccountIds' : IDL.Func([], [], []),
    'generateLowercaseHandles' : IDL.Func(
        [],
        [IDL.Text, IDL.Vec(IDL.Text)],
        [],
      ),
    'getActiveUsersByRange' : IDL.Func([Date], [IDL.Nat], ['query']),
    'getAdmins' : IDL.Func([], [Result_9], ['query']),
    'getAllClaimSubaccountIndexes' : IDL.Func([], [Result_15], ['query']),
    'getAllHandles' : IDL.Func([], [IDL.Vec(IDL.Text)], ['query']),
    'getAllUserPrincipals' : IDL.Func([], [Result_9], ['query']),
    'getCanisterMetrics' : IDL.Func(
        [GetMetricsParameters],
        [IDL.Opt(CanisterMetrics)],
        ['query'],
      ),
    'getCanisterVersion' : IDL.Func([], [IDL.Text], ['query']),
    'getCgUsers' : IDL.Func([], [Result_9], ['query']),
    'getDailyMaxRegistration' : IDL.Func([], [IDL.Nat], ['query']),
    'getDeadEmailBatches' : IDL.Func([], [Result_11], ['query']),
    'getEmailSubscribersOfAuthor' : IDL.Func(
        [IDL.Text],
        [Result_14],
        ['query'],
      ),
    'getEmailSubscribersOfPublication' : IDL.Func(
        [IDL.Text],
        [Result_14],
        ['composite_query'],
      ),
    'getFollowersByPrincipalId' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(UserListItem)],
        ['query'],
      ),
    'getFollowersCount' : IDL.Func([IDL.Text], [IDL.Text], ['query']),
    'getFollowersPrincipalIdsByPrincipalId' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(IDL.Text)],
        ['query'],
      ),
    'getHandleByPrincipal' : IDL.Func(
        [IDL.Text],
        [GetHandleByPrincipalReturn],
        ['query'],
      ),
    'getHandlesByAccountIdentifiers' : IDL.Func(
        [IDL.Vec(IDL.Text)],
        [IDL.Vec(IDL.Text)],
        ['query'],
      ),
    'getHandlesByPrincipals' : IDL.Func(
        [IDL.Vec(IDL.Text)],
        [IDL.Vec(IDL.Text)],
        ['query'],
      ),
    'getLastDayClaimedTokensAmount' : IDL.Func([], [IDL.Nat], ['query']),
    'getLastDayNumberOfClaimEvents' : IDL.Func([], [IDL.Nat], ['query']),
    'getLinkedPrincipal' : IDL.Func([IDL.Text], [Result_2], ['query']),
    'getMaxMemorySize' : IDL.Func([], [IDL.Nat], ['query']),
    'getMemorySize' : IDL.Func([], [IDL.Nat], ['query']),
    'getMultipleUsersByPrincipalId' : IDL.Func(
        [IDL.Vec(IDL.Text)],
        [Result_13],
        ['query'],
      ),
    'getMyFollowers' : IDL.Func([], [Result_12], ['query']),
    'getNuaBalance' : IDL.Func([IDL.Text], [NuaBalanceResult], ['query']),
    'getNumberOfAllRegisteredUsers' : IDL.Func([], [IDL.Nat], ['query']),
    'getPendingEmailBatches' : IDL.Func([], [Result_11], ['query']),
    'getPlatformOperators' : IDL.Func([], [List], ['query']),
    'getPrincipalByHandle' : IDL.Func(
        [IDL.Text],
        [GetPrincipalByHandleReturn],
        ['query'],
      ),
    'getPrincipalsByHandles' : IDL.Func(
        [IDL.Vec(IDL.Text)],
        [IDL.Vec(IDL.Text)],
        ['query'],
      ),
    'getRegistrationNumberLastDay' : IDL.Func([], [IDL.Nat], ['query']),
    'getTotalNumberOfClaimedTokens' : IDL.Func([], [IDL.Nat], ['query']),
    'getTrustedCanisters' : IDL.Func([], [Result_9], ['query']),
    'getUser' : IDL.Func([], [Result_1], ['query']),
    'getUserByHandle' : IDL.Func([IDL.Text], [Result_1], ['query']),
    'getUserByPrincipalId' : IDL.Func([IDL.Text], [Result_1], ['query']),
    'getUserFollowers' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(UserListItem)],
        ['query'],
      ),
    'getUserInternal' : IDL.Func([IDL.Text], [IDL.Opt(User)], ['query']),
    'getUserListItemByHandle' : IDL.Func([IDL.Text], [Result_10], ['query']),
    'getUsersBlockedFromClaiming' : IDL.Func([], [Result_9], ['query']),
    'getUsersByHandles' : IDL.Func(
        [IDL.Vec(IDL.Text)],
        [IDL.Vec(UserListItem)],
        ['query'],
      ),
    'getUsersByPrincipals' : IDL.Func(
        [IDL.Vec(IDL.Text)],
        [IDL.Vec(UserListItem)],
        ['query'],
      ),
    'getVerificationStatus' : IDL.Func([IDL.Text], [Result_6], ['query']),
    'handleClap' : IDL.Func([IDL.Text, IDL.Text], [], ['oneway']),
    'hasLettermintApiKey' : IDL.Func([], [IDL.Bool], ['query']),
    'icrc10_supported_standards' : IDL.Func(
        [],
        [IDL.Vec(SupportedStandard)],
        ['query'],
      ),
    'icrc28_trusted_origins' : IDL.Func([], [Icrc28TrustedOriginsResponse], []),
    'isEmailSubscribed' : IDL.Func([IDL.Text, IDL.Text], [IDL.Bool], ['query']),
    'isEmailSubscribedByCaller' : IDL.Func(
        [IDL.Text, IDL.Opt(IDL.Text)],
        [IDL.Bool],
        ['query'],
      ),
    'isRegistrationOpen' : IDL.Func([], [IDL.Bool], ['query']),
    'isThereEnoughMemory' : IDL.Func([], [IDL.Bool], ['query']),
    'linkInternetIdentityConfirm' : IDL.Func([IDL.Text], [Result_3], []),
    'linkInternetIdentityRequest' : IDL.Func(
        [IDL.Text, IDL.Text],
        [Result_3],
        [],
      ),
    'migrateFollowersHashmapsFromHandlesToPrincipalIds' : IDL.Func(
        [],
        [Result_8],
        [],
      ),
    'notifyAuthorArticlePublished' : IDL.Func(
        [PublishedArticlePayload, IDL.Vec(IDL.Text), IDL.Vec(IDL.Text)],
        [Result_7],
        [],
      ),
    'processPendingEmailBatchesNow' : IDL.Func([], [Result_2], []),
    'registerAdmin' : IDL.Func([IDL.Text], [Result_3], []),
    'registerCanister' : IDL.Func([IDL.Text], [Result_3], []),
    'registerCgUser' : IDL.Func([IDL.Text], [Result_3], []),
    'registerPlatformOperator' : IDL.Func([IDL.Text], [Result_3], []),
    'registerUser' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text],
        [RegisterUserReturn],
        [],
      ),
    'removePoh' : IDL.Func([IDL.Text], [Result_1], []),
    'removePublication' : IDL.Func(
        [PublicationObject__1, IDL.Text],
        [RemovePublicationReturn],
        [],
      ),
    'retryDeadEmailBatch' : IDL.Func([IDL.Text], [Result_2], []),
    'setDailyMaxRegistration' : IDL.Func([IDL.Nat], [Result_5], []),
    'setIsClaimActive' : IDL.Func([IDL.Bool], [Result_6], []),
    'setLettermintApiKey' : IDL.Func([IDL.Text], [Result_3], []),
    'setMaxMemorySize' : IDL.Func([IDL.Nat], [Result_5], []),
    'setMaxNumberOfClaimableTokens' : IDL.Func([IDL.Nat], [Result_5], []),
    'setMaxNumberOfDailyClaimableTokens' : IDL.Func([IDL.Nat], [Result_5], []),
    'spendNuaBalance' : IDL.Func([IDL.Text], [], ['oneway']),
    'spendRestrictedTokensForSubscription' : IDL.Func(
        [IDL.Text, IDL.Nat],
        [Result_4],
        [],
      ),
    'spendRestrictedTokensForTipping' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Nat],
        [Result_3],
        [],
      ),
    'subscribeToAuthorByEmail' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text],
        [Result_2],
        [],
      ),
    'subscribeToPublicationByEmail' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Text, IDL.Text],
        [Result_2],
        [],
      ),
    'testInstructionSize' : IDL.Func([], [IDL.Text], []),
    'unblockUserFromClaiming' : IDL.Func([IDL.Text], [Result_3], []),
    'unfollowAuthor' : IDL.Func([IDL.Text], [Result_1], []),
    'unregisterAdmin' : IDL.Func([IDL.Text], [Result_3], []),
    'unregisterCanister' : IDL.Func([IDL.Text], [Result_3], []),
    'unregisterCgUser' : IDL.Func([IDL.Text], [Result_3], []),
    'unregisterPlatformOperator' : IDL.Func([IDL.Text], [Result_3], []),
    'unsubscribeEmailByCaller' : IDL.Func(
        [IDL.Text, IDL.Opt(IDL.Text)],
        [Result_2],
        [],
      ),
    'unsubscribeEmailByToken' : IDL.Func([IDL.Text, IDL.Text], [Result_2], []),
    'unsubscribeFromAuthorByEmail' : IDL.Func(
        [IDL.Text, IDL.Text],
        [Result_2],
        [],
      ),
    'updateAvatar' : IDL.Func([IDL.Text], [Result_1], []),
    'updateBio' : IDL.Func([IDL.Text], [Result_1], []),
    'updateDisplayName' : IDL.Func([IDL.Text], [Result_1], []),
    'updateFontType' : IDL.Func([IDL.Text], [Result_1], []),
    'updateHandle' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Opt(IDL.Vec(IDL.Text))],
        [Result_1],
        [],
      ),
    'updateLastLogin' : IDL.Func([], [], ['oneway']),
    'updateSocialLinks' : IDL.Func(
        [IDL.Text, IDL.Vec(IDL.Text)],
        [Result_1],
        [],
      ),
    'updateUserDetails' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Text, IDL.Vec(IDL.Text)],
        [Result_1],
        [],
      ),
    'validate' : IDL.Func([IDL.Reserved], [Validate], []),
    'verifyEmailSubscription' : IDL.Func([IDL.Text], [Result], []),
    'verifyPoh' : IDL.Func([IDL.Text, IDL.Text, IDL.Text], [VerifyResult], []),
  });
};
export const init = ({ IDL }) => { return []; };
